import React from "react";
import ReflectionRichText from "./ReflectionRichText.js";
import { getBehaviorPatternMeta } from "../constants/behaviorPatterns.js";

const BehaviorPatternInsight = ({ pattern, action, className = "" }) => {
  const meta = getBehaviorPatternMeta(pattern);
  if (!meta) return null;

  return (
    <div className={`behavior-pattern-insight ${className}`.trim()}>
      <p className="behavior-pattern-insight__pattern">
        You may be experiencing <strong>{meta.key}</strong>
      </p>
      <p className="behavior-pattern-insight__counter">{meta.counterLine}</p>
      {action ? (
        <div className="behavior-pattern-insight__action">
          <h3 className="behavior-pattern-insight__action-title">Small action</h3>
          <ReflectionRichText className="behavior-pattern-insight__action-body" text={action} />
        </div>
      ) : (
        <p className="behavior-pattern-insight__guide">{meta.guide}</p>
      )}
    </div>
  );
};

export default BehaviorPatternInsight;
